<template>
    <div class="InvoiceLsit">
        <el-empty v-if="list.length === 0"></el-empty>
        <div class="item" v-for="(item, index) in list" :key="index">
            <div class="head">
                <div class="left">
                    <div class="info-item">{{ item.createdTime }}</div>
                    <div class="info-item">订单号：{{ item.orderNo }}</div>
                </div>
                <div class="right">
                    <div class="status" v-if="item.invoiceStatus == 1">待开票</div>
                    <div class="status" v-else-if="item.invoiceStatus == 2" style="color: #00b919">已开票</div>
                </div>
            </div>
            <div class="body">
                <div class="goods-item" v-for="(item2, index2) in item.products" :key="index2">
                    <div class="goods">
                        <div class="image-warp">
                            <el-image class="elImg" :src="item2.image" fit="cover"></el-image>
                        </div>
                        <div class="info-warp">{{ item2.title }}</div>
                    </div>
                    <div class="item-info">{{ item2.keyVals }}</div>
                    <div class="item-info">× {{ item2.num }}</div>
                    <div class="item-info">{{ item2.priceSale }}元</div>
                </div>
            </div>
            <div class="footer">
                <div class="left">
                    共&nbsp&nbsp<span style="color: #ff4d00; font-weight: bold">{{ item.products.length }}</span
                    >&nbsp&nbsp个商品&nbsp&nbsp&nbsp合计金额
                    <!-- <span style="color: #ff4d00; font-weight: bold">{{ moneyCount(item.products) }}元</span> -->
                    <span style="color: #ff4d00; font-weight: bold">{{ item.price }}元</span>
                </div>
                <div class="right">
                    <button class="normal btn-ripple" @click="handle_buttons('开票详情', item)">开票详情</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        list: {
            type: Array | Number,
            default: () => {
                return []
            },
        },
    },
    components: {},
    name: 'InvoiceLsit',
    data() {
        return {
            // typeMap: {
            // 	1: { icon: require('../img/refund-1.png'), title: '仅退款' },
            // 	2: { icon: require('../img/refund-2.png'), title: '退货退款' },
            // 	3: { icon: require('../img/refund-3.png'), title: '换货' }
            // }
        }
    },
    computed: {
        moneyCount() {
            function isArray(arg) {
                if (typeof Array.isArray === 'undefined') {
                    return Object.prototype.toString.call(arg) === '[object Array]'
                }
                return Array.isArray(arg)
            }
            return (val) => {
                if (isArray(val)) {
                    let num = 0
                    for (let index = 0; index < val.length; index++) {
                        let item = val[index]
                        num += Number(item.priceSale)
                    }
                    return num
                } else {
                    return []
                }
            }
        },
    },
    watch: {},
    created() {},
    methods: {
        updateView() {
            this.$emit('updateView')
        },
        handle_buttons(flag, item) {
            switch (flag) {
                case '开票详情':
                    this.$router.push({
                        path: `/invoice-detail`,
                        query: {
                            invoiceId: item.id,
                            orderId: item.typeId,
                        },
                    })
                    break
                default:
                    break
            }
        },
    },
}
</script>

<style lang="less" scoped>
.InvoiceLsit {
    .item + .item {
        margin-top: 24px;
    }
    .item {
        border: 1px solid #e5e5e5;
        transition: 0.3s all;
        // &:hover {
        //     box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.2);
        // }
        .head {
            display: flex;
            padding: 12px 24px;
            background: #f5f5f5;
            border-bottom: 1px solid #e5e5e5;
            .left {
                flex: 1;
                display: flex;
                align-items: center;
                .info-item {
                    font-weight: bold;
                    font-size: 14px;
                    color: #333333;
                }
                .info-item + .info-item {
                    margin-left: 40px;
                }
            }
            .right {
                .status {
                    font-weight: 400;
                    font-size: 14px;
                    color: #ff4d00;
                }
            }
        }
        .body {
            .goods-item {
                display: flex;
                padding: 24px;

                font-weight: 400;
                font-size: 14px;
                color: #333333;
                border-bottom: 1px solid #e5e5e5;
                .goods {
                    display: flex;
                    align-items: center;

                    .image-warp {
                        width: 120.34px;
                        height: 83.22px;
                        border: 1px solid #9f9f9f;
                        margin-right: 15px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        .elImg {
                            width: 120.34px;
                            height: 83.22px;
                        }
                    }
                    .info-warp {
                        width: 319px;
                        p {
                            line-height: 18px;
                        }
                        p:nth-of-type(1) {
                            height: 36px;
                            display: -webkit-box;
                            -webkit-box-orient: vertical;
                            text-overflow: ellipsis;
                            overflow: hidden;
                            -webkit-line-clamp: 2;
                        }
                    }
                }
                .item-info {
                    display: flex;
                    align-items: center;
                    justify-content: flex-end;
                    flex: 1;
                    button {
                        min-width: 104px;
                        height: 32px;
                        padding: 0 24px;
                        background: #ffffff;
                        border-radius: 4px 4px 4px 4px;
                        border: 1px solid #cecece;
                        font-weight: 400;
                        font-size: 14px;
                        color: #676767;
                        cursor: pointer;
                        transition: 0.2s all;
                        &:hover {
                            opacity: 0.75;
                        }
                    }
                }
            }
        }
        .footer {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 14px 24px;
            .left {
                font-weight: 400;
                font-size: 14px;
                color: #333333;
                line-height: 14px;
            }
            .right {
                display: flex;
                align-items: center;
                button + button {
                    margin-left: 14px;
                }
                button {
                    min-width: 104px;
                    padding: 6px 24px;

                    border-radius: 4px 4px 4px 4px;
                    font-weight: 400;
                    font-size: 14px;

                    cursor: pointer;
                    transition: 0.2s all;
                    &:hover {
                        opacity: 0.7;
                    }
                }
                button.theme {
                    background: #ff4d00;
                    border: 1px solid #ff4d00;
                    color: #fff;
                }
                button.normal {
                    width: 104px;
                    height: 32px;
                    background: #ffffff;
                    border-radius: 0px 0px 0px 0px;
                    border: 1px solid #ff4d00;
                    font-weight: 400;
                    font-size: 14px;
                    color: #ff4d00;
                    line-height: 32px;
                    text-align: center;
                    white-space: nowrap;
                    padding: 0;
                }
            }
        }
    }
}
</style>
